import React, { useContext, useMemo } from "react";
import { ICON_THEME_MAP, THEME_LABEL } from "./constant";
import { ThemeContext } from "./theme-context/index";

import "./ThemeToggler.css";

function ThemeToggler(props) {
    const { isSideBarMinimized } = props;
    const { theme, setTheme } = useContext(ThemeContext);

    const themeLabel = useMemo(() => {
        let label = THEME_LABEL[theme];

        if (isSideBarMinimized) {
            label = ""
        }

        return label;
    }, [isSideBarMinimized, theme]);

    return (
        <div
            className="theme-toggler"
            style={{ display: props.enabled ? "flex" : "none" }}
            onClick={setTheme}
        >
            <span className="theme-toggler__icon">
                {ICON_THEME_MAP[theme]}
            </span>

            <span className="theme-toggler__text">
                {themeLabel}
            </span>
        </div>
    )
}

export default ThemeToggler;
